import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/humedad.png";
import Imagen2 from "../../../images/modulo13/unsolocano.png";

const Actividad8 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[8];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[7].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[7].path}`,
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[9].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[9].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
            <h2 className="mb-4">Ciudades sin planificación</h2>
            <p>
              Lo anterior ha ocasionado, por un lado, la intensa{" "}
              <strong>concentración de personas</strong> en espacios reducidos,
              sin acceso a servicios públicos básicos.
            </p>
            <p>
              El <strong>crecimiento acelerado</strong> de las ciudades en el
              Perú se ha dado sin mayor planificación. Esto ocurre también en
              muchos otros países del mundo.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-3 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-9 col-12 p-4 p-md-5">
            <p>
              Por otro lado, la falta de planificación afecta también al
              ambiente pues causa profundas{" "}
              <strong>transformaciones en el entorno</strong>. Ejemplo de ello
              es el exceso de ruidos, la contaminación del aire, el incremento
              de tránsito, la sobrecarga de redes eléctricas y de desagües, la
              generación excesiva de basura, etc.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean, por turnos y en voz alta, el texto titulado Ciudades
            sin planificación. Pida que en la lectura presten atención a los
            problemas que trae la construcción de ciudades sin planificar.
          </li>
          <li>
            Comente que la planificación de las ciudades permite su crecimiento
            de manera ordenada, la identificación previa de las necesidades y
            los recursos disponibles. Además, tener en cuenta el diseño de
            infraestructura y servicios, así como la manera en que se usan los
            suelos y los espacios públicos, impacta en la calidad de vida de sus
            residentes.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
